// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__QQJ8_","ctaContent":"styles_ctaContent__MawhQ"};